export type ThemePalette = typeof palette;

const brand = {
  brand900: '#2C0E87',
  brand800: '#3613A0',
  brand700: '#421BB8',
  brand600: '#5027CD',
  brand500: '#6238DD',
  brand400: '#7750E9',
  brand300: '#9170F2',
  brand200: '#B098F9',
  brand100: '#D3C5FD',
  brand50: '#F7F5FF'
} as const;

const bg = {
  bg900: '#18161C',
  bg800: '#1E1B24',
  bg700: '#262231',
  bg500: '#373245',
  bg400: '#413D50'
} as const;

const grayscale = {
  grayscale900: '#242327',
  grayscale800: '#3F3D43',
  grayscale700: '#595463',
  grayscale600: '#756F7E',
  grayscale500: '#948F9E',
  grayscale400: '#BCB8C3',
  grayscale300: '#D7D3DE',
  grayscale200: '#E8E3EE',
  grayscale100: '#EBE9F4',
  grayscale50: '#FAFAFA'
} as const;

const gray = {
  gray15: '#EAE8ED',
  gray25: '#C9C7D1',
  gray100: '#8E899F',
  gray300: '#5C576B',
  gray400: '#4D495A',
  gray500: '#383441',
  gray600: '#2E2B36',
  gray700: '#24222A',
  gray800: '#1F1E25'
};

export const palette = {
  ...brand,
  ...bg,
  ...grayscale,
  ...gray
} as const;
